import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BulkCreationReport, BulkDeletionResponse, Vehicle, VehicleRequest, VehiclesBlocked, VehiclesResponse } from './vehicle.model';

export abstract class VehicleRepository {
    abstract create(vehicle: VehicleRequest): Observable<Vehicle>;
    abstract getVehicle(id: number): Observable<Vehicle>;
    abstract getVehicles(page: number, pageSize: number, search?: string): Observable<VehiclesResponse>;
    abstract deleteVehicle(id: number): Observable<void>;
    abstract retryVehicle(id: number): Observable<Vehicle>;
    abstract updateEndDate(id: number, endDate: string): Observable<Vehicle>;
    abstract updateNickName(id: number, nickname: string): Observable<Vehicle>;
    abstract getVehiclesBlocked(): Observable<VehiclesBlocked>;
    abstract uploadCsv(file: File): Observable<BulkCreationReport>;
    abstract bulkDelete(file: File, persist: boolean): Observable<BulkDeletionResponse>;
    abstract exportVehiclesCsv(): Observable<HttpResponse<Blob>>;
}
